import React from 'react';

import { clearHtmlTags } from '@/helpers/HtmlHelper/clearHtmlTags';
import { getValue } from '@/helpers/GetValueHelper';

import { ICardProps } from './interface';

export const Card = React.memo(({ data, onClick }: ICardProps) => {
  const { id, icon, title, label } = data;
  const link = getValue(data, 'cta[0].link');
  const imageUrl = getValue(data, 'image.image.url');

  return (
    <a
      href={link}
      data-link={link}
      title={clearHtmlTags(title)}
      className="vitrine-template5__card"
      key={id}
      data-id={id}
      onClick={e => onClick(e, id)}
      target="_blank"
      rel="noreferrer"
    >
      <img
        className="vitrine-template5__card-image"
        src={imageUrl}
        alt={clearHtmlTags(title)}
      />
      <img src={icon} className="vitrine-template5__card__icon" alt="" />
      <span
        className="vitrine-template5__card__text"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: (label ?? '') + title }}
      />
    </a>
  );
});
